import { defineComponent as _defineComponent } from 'vue'
import { Trade } from 'ah-api-gateways';
import { BModal } from 'bootstrap-vue';
import { PropType, ref } from 'vue';
import TradeDetails from './TradeDetails.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeDetailsModal',
  props: {
  trade: {
    type: Object as PropType<Trade>,
    required: false,
  },
},
  setup(__props, { expose }) {

const modal = ref<BModal | null>(null);



expose({
  modal,
});

return { __sfc: true,modal, BModal, TradeDetails }
}

})